import { SubjectPayloadInterface } from "../../Constants/Interfaces/payloadInterface/SubjectPayload.interface";
import { isEmpty } from "../../utils/array.utils";

const SUBJECT_TYPES_REQUIRING_MARKS = new Set(["ACADEMIC", "GRADE_SPECIFIC"]);

export const validateSubjectForm = (
  values: SubjectPayloadInterface
): string | null => {
  if (!values.name) {
    return "Subject name is required.";
  }

  if (!values.subject_type) {
    return "Please select subject type.";
  }

  if (!values.classDetails || isEmpty(values.classDetails)) {
    return "Please select at least one class.";
  }

  if (SUBJECT_TYPES_REQUIRING_MARKS.has(values.subject_type)) {
    const missingMarks = values.classDetails.some(
      ({ subject_marks }) =>
        subject_marks === null ||
        subject_marks === undefined ||
        Number.isNaN(Number(subject_marks)) ||
        Number(subject_marks) <= 0
    );

    if (missingMarks) {
      return "Please provide valid full marks for each selected class.";
    }
  }

  return null;
};
